import type { IssueTypeScreenSchemesFilter } from '@atlassian/jira-admin-screens-services/src/services/issue-type-screen-schemes-service/types.tsx';
import { calculateMaximumPage } from '@atlassian/jira-admin-screens-services/src/utils.tsx';

export const extractAnalyticsAttributes = (
	filter: IssueTypeScreenSchemesFilter,
	totalIssueTypeScreenSchemes: number,
): {
	[key: string]: string | number | boolean | undefined;
} => ({
	currentPage: filter.pageNumber,
	maximumPage: calculateMaximumPage(filter.pageSize, totalIssueTypeScreenSchemes),
	pageSize: filter.pageSize,
	total: totalIssueTypeScreenSchemes,
});
